exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Bolt-module__wrapper___3DjRy{width:40px;height:40px;position:relative}.Bolt-module__wrapper___3DjRy button img{height:100%}.Bolt-module__wrapper___3DjRy h6{font-weight:600}.Bolt-module__wrapper___3DjRy .Bolt-module__empty___2tiAE{width:200px;font-size:14px;color:#fff}", ""]);

// exports
exports.locals = {
	"wrapper": "Bolt-module__wrapper___3DjRy",
	"empty": "Bolt-module__empty___2tiAE"
};